var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pro-badge"},[_vm._v("Pro")])
}
var staticRenderFns = []

export { render, staticRenderFns }